import ApplicationController from '../application_controller';
import GestorSeleccionListado from '../utils/GestorSeleccionListado';
import { t } from '../../../../libs/i18n';
import gestionServicios from '../../../../api/cifra/servicios/gestion_servicios';

/*
  Gestiona el listado de la gestión de servicios
*/
export default class extends ApplicationController {
  connect() {
    this.gestorSeleccionListado = new GestorSeleccionListado(this.element);
    this.gestorSeleccionListado.connect();
    this.#conectarBotones();
  }

  #conectarBotones() {
    this.#botonActivarSolicitudes();
    this.#botonDesactivarSolicitudes();
  }

  #botonActivarSolicitudes() {
    this.gestorSeleccionListado.confirmarBotonAccion(
      this.element.querySelector('#activar-solicitudes'),
      t('activar_solicitudes'),
      'Se van a <b>activar</b> las solicitudes de nuevas suscripciones a los servicios seleccionados, ¿Está seguro de querer continuar?',
      gestionServicios.activarSolicitudes,
    );
  }

  #botonDesactivarSolicitudes() {
    this.gestorSeleccionListado.confirmarBotonAccion(
      this.element.querySelector('#desactivar-solicitudes'),
      t('desactivar_solicitudes'),
      'Se van a <b>desactivar</b> las solicitudes de nuevas suscripciones a los servicios seleccionados, ¿Está seguro de querer continuar?',
      gestionServicios.desactivarSolicitudes,
    );
  }
}
